const PoolCreate = () => import("@/components/Admin/Pool/PoolCreate");
const PoolEdit = () => import("@/components/Admin/Pool/PoolEdit");
const PoolIndex = () => import("@/components/Admin/Pool/PoolIndex");
const PoolView = () => import("@/components/Admin/Pool/PoolView");

const routes = [
  {
    name: "PoolIndex",
    path: "/pools",
    component: PoolIndex,
    meta: {
      title: "Pools",
      sidebar: true
    }
  },
  {
    name: "PoolCreate",
    path: "/pools/create/:ref",
    component: PoolCreate,
    meta: {
      title: "Create pool",
      sidebar: true
    }
  },
  {
    name: "PoolView",
    path: "/pools/:ref/:id",
    component: PoolView,
    meta: {
      title: "View pool",
      sidebar: true
    }
  },
  {
    name: "PoolEdit",
    path: "/pools/:id/edit",
    component: PoolEdit,
    meta: {
      title: "Edit pool",
      sidebar: true
    }
  }
];

export default routes;
